<template>
  <div v-if="!loading" class="results" :class="guest ? 'container':''">
    <h2 class="profile__header header">
      <div> {{ $t('consultations.header') }}</div>
      <span v-if="selectedDoctor" class="doctor">
                {{ selectedDoctor.name }}
            </span>

      <span v-if="selectedSpecialization" class="specialization">
                {{ selectedSpecialization.title }}
            </span>

      <span v-if="selectedClinic" class="clinic">
                {{ selectedClinic.short_title }}
            </span>

      <router-link v-if="displayChangeExecutorButton" class="icon__edit"
                   :to="routerLinkOrderChooseDoctor"></router-link>
    </h2>

    <div class="col-12">
      <div class="row">
        <div class="col-8">
          <div v-if="loading">
            <div class="col-6 offset-6">
              <!-- Preloader -->
              <div class="circonf-wrapper">
                <div class="circonf circonf-1">
                </div>
                <p>{{ $t('common.query_in_process') }}</p>
                <p>{{ $t('common.not_reload_page') }}</p>
              </div>
              <!-- End of Preloader -->
            </div>
          </div>

          <div v-if="!loading && time_table_groups.length === 0">
            {{ $t('consultations.seance_not_found') }}
          </div>

          <div v-if="!loading && time_table_groups.length !== 0">
            <time-table-input v-if="time_table_groups && clinics"
                              :time_table_groups="time_table_groups"
                              :clinics="clinics"
                              :choose-clinic="selectedClinic !== null"
                              @input="onSelectTimeTable"></time-table-input>
            <div v-if="seanceLoading" class="text-center mt-5 d-flex justify-content-center">
              <b-spinner
                  variant="primary"
              ></b-spinner>
            </div>
            <button class="btn btn-inline pull-right"
                    v-if="!seanceLoading"
                    :disabled="disableConfirmButton"
                    @click="openInfoModal">
              {{ $t('buttons.confirm') }}
            </button>

            <div class="mt-3">
            </div>
          </div>
        </div>

        <div class="col-4" v-if="!loading">
          <div class="doctor-not-found-card card">
            <span class="header">{{ $t('consultations.not_found_card_timetable.header') }}</span>
            <span class="text">{{ $t('consultations.not_found_card_timetable.text') }}</span>
            <span class="phone">+38 (048) 730-00-30</span>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="confirmationModal" centered hide-footer :title="$t('common.check_data')"
             @hide="rollbackPrepareInfoAgree">
      <div v-if="selectedSpecialization" class="specialization">
        <b>{{ $t('consultations.specialization') }}:</b> {{ selectedSpecialization.title }}
      </div>

      <div v-if="selectedDoctor" class="doctor mt-1">
        {{ selectedDoctor.name }}
      </div>

      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.department') }}:</b> {{ selectedClinic.title }}
      </div>
      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.address') }}:</b> {{ selectedClinic.address }}
      </div>
      <div v-if="selected_time_table" class="mt-1">
        <b>{{ $t('consultations.seance_time') }}:</b> {{ formatTime(selected_time_table.start_time, 'D MMM YYYY') }}
        &nbsp; {{ formatTime(selected_time_table.start_time, 'HH:mm') }}
      </div>

      <div v-if="selected_time_table_info && !isFamilyDoctor" class="mt-1">
        <b>{{ $t('consultations.seance_amount') }}:</b> {{ selected_time_table_info.price }} грн.
      </div>

      <div v-if="selected_time_table_info && !selected_time_table_info.available" class="mt-1">
        <b>{{ $t('errors.seance_busy') }}</b>
      </div>
      <template v-else>
        <template v-if="!guest">
          <div class="my-3 text-center d-flex justify-content-center" v-if="paymentLoading">
            <b-spinner
                variant="primary"
            ></b-spinner>
          </div>
          <div class="mt-3" v-if="selected_time_table_info && !paymentLoading && isCanBePayed">
            <button v-if="!isFamilyDoctor" class="btn text-white btn-font-default pt-3" style="line-height: 14px;"
                    :disabled="!selected_time_table_info.available" @click="orderDoctorTimeTable">
              {{ $t('buttons.pay_seance') }}
              <br>
              <br>
              <p style="font-weight: normal;font-size: 12px;">
                <span class="text-danger">*</span> {{ $t('common.pay_warning') }}
              </p>
            </button>
          </div>
          <div class="mt-1" v-if="selected_time_table_info && !paymentLoading">
            <div v-if="isReservation.reservation">
              <button class="btn btn-blue-sky btn-font-default py-2" @click="makeReservation">
                {{ $t('buttons.reserve') }}
              </button>
              <b-form-checkbox
                  name="noNeedCheckbox"
                  unchecked-value="not_accepted"
                  v-model="noNeedCheckbox"
              >
                {{ $t('common.not_callback') }}
              </b-form-checkbox>
            </div>
            <div v-if="isReservation.operatorCall">
              <button class="btn btn-blue-sky btn-font-default" @click="callOperator">
                {{ $t('common.operator_call') }}
              </button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mt-3" v-if="selected_time_table_info">
            <button class="btn" :disabled="!selected_time_table_info.available" @click="orderGuest">
              {{ $t('buttons.confirm') }}
            </button>
          </div>
        </template>
      </template>
      <div v-if="selected_time_table_info" class="mt-1 text-center">
        <button class="btn btn-link btn-link-clear" @click="cancelTimeTable()">
          <template v-if="!selected_time_table_info.available"> {{ $t('buttons.hide') }}</template>
          <template v-else>{{ $t('buttons.cancel') }}</template>
        </button>
      </div>
    </b-modal>
    <operator-modal :show="showOperatorModal"/>

    <prepare-info-modal
        :show="showPrepareInfoModal"
        :time_table_info="selected_time_table_info"
        :selected_specialization="selectedSpecialization"
        @closePrepareModal="closeInfoModal"

    />

    <b-modal ref="successModal" centered hide-footer :title="patient.name" @hide="redirect({name:'profile'})">
      <div v-if="selectedSpecialization" class="specialization">
        <b>{{ $t('consultations.specialization') }}:</b> {{ selectedSpecialization.title }}
      </div>

      <div v-if="selectedDoctor" class="doctor mt-1">
        {{ selectedDoctor.name }}
      </div>

      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.department') }}:</b> {{ selectedClinic.title }}
      </div>
      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.address') }}:</b> {{ selectedClinic.address }}
      </div>
      <div v-if="selected_time_table" class="mt-1">
        <b>{{ $t('consultations.seance_time') }}:</b> {{ formatTime(selected_time_table.start_time, 'D MMM YYYY') }}
        {{ $t('consultations.from') }} {{ formatTime(selected_time_table.start_time, 'HH:mm') }}
        {{ $t('consultations.to') }} {{ formatTime(selected_time_table.end_time, 'HH:mm') }}
      </div>

      <div v-if="selected_time_table_info" class="mt-1">
        <b>{{ $t('consultations.seance_amount') }}:</b> {{ selected_time_table_info.price }} грн.
      </div>
      <div class="mt-1 d-flex justify-content-center">
        <button class="btn btn-link btn-link-clear" @click="closeSuccessModal">{{ $t('buttons.hide') }}</button>
      </div>

    </b-modal>
  </div>
  <div v-else class="flex-column text-center align-content-center vh-100">
    <b-spinner
        variant="primary"
    ></b-spinner>
  </div>
</template>

<script>
import moment from 'moment';
import config from '@/helpers/configDateFormats';
import TimeTableInput from '@/components/TimeTableInput'
import { mapGetters } from "vuex";
import OperatorModal from "@/components/operatorModal";
import prepareInfoModal from "@/components/prepareInfoModal";
import getSettings from "@/api/settings/getSettings";
import store from "@/store";

export default {
  name: 'order-choose-doctor-time-table',
  props: {
    doctor_id: {
      required: true,
      type: String,
    },
    specialization_id: {
      required: false,
      type: [Number, String],
    },
    clinic_id: {
      required: false,
      type: [Number, String],
    },
    guest: {
      default: false,
      type: [Boolean],
    },
    my_doctor: {
      required: false,
    },
  },
  data() {
    return {
      selectedDoctor: null,
      selectedSpecialization: null,
      selectedClinic: null,

      selected_time_table: null,
      selected_time_table_info: null,

      time_table_groups: [],
      order_info: null,

      loading: true,
      seanceLoading: false,
      paymentLoading: false,

      agreeWithPrepareInfo: false,

      noNeedCheckbox: true,

      showOperatorModal: false,
      showPrepareInfoModal: false
    }
  },
  watch: {
    agreeWithPrepareInfo() {
      if (this.agreeWithPrepareInfo === true) {
        this.openConfirmationModal();
      }
    }
  },
  methods: {
    /** UI methods **/
    closeInfoModal(agree) {
      this.showPrepareInfoModal = false
      this.seanceLoading = false
      this.agreeWithPrepareInfo = agree
    },
    openInfoModal() {
      if (this.selected_time_table_info?.service_prepare_info_id) {
        this.showPrepareInfoModal = true
      } else {
        this.closeInfoModal(true);
      }
    },
    openSuccessModal() {
      this.$refs.successModal.show()
    },
    closeSuccessModal() {
      this.$refs.successModal.hide();
    },
    redirect(payload = {}) {
      this.$router.push(payload);
    },
    openConfirmationModal() {
      this.$refs.confirmationModal.show();
    },
    closeConfirmationModal() {
      this.$refs.confirmationModal.hide();
    },
    openOperatorModal() {
      this.showOperatorModal = true
    },
    formatTime(date, format = 'HH:mm') {
      return moment(date).format(format);
    },

    /** Helper methods**/
    cancelTimeTable() {
      this.closeConfirmationModal()
    },
    rollbackPrepareInfoAgree() {
      this.agreeWithPrepareInfo = false;
    },
    navigateProfile() {
      if (!this.guest) {
        this.$router.push({
          name: 'profile',
        });
      }
    },

    orderGuest() {
      this.$router.push({
        name: 'order.guest',
        query: {
          type: 'specialization',
          service_id: this.selected_time_table.service_id,
          time_table_id: this.selected_time_table.id,
          doctor_id: this.selected_time_table.doctor_id,
        },
      })
    },
    moveToPaymentPage(data) {
      let params = data;
      let url = params.url

      this.closeConfirmationModal()
      let newWindow = window.open()
      let newWindowDocument = newWindow.document;
      newWindowDocument.open("text/html", "replace");
      newWindowDocument.write(data);

      newWindowDocument.close();
      this.$router.push({name: 'profile'})
    },

    /** Make order methods **/
    callOperator() {
      this.$store
          .dispatch('orderDoctorTimeTable', {
            timetable_id: this.selected_time_table.id,
            service_id: this.selected_time_table.service_id,
            pay: 0,
            reserve: 1,
            need_callback: 1
          })
          .then(order_info => {
            this.order_info = order_info;
            this.closeConfirmationModal()
            this.openOperatorModal()
            this.fetch();
            this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']});
            this.$store
                .dispatch('getUserInfo');
          });
    },
    orderDoctorTimeTable() {
      this.paymentLoading = true
      this.$store
          .dispatch('orderDoctorTimeTable', {
            timetable_id: this.selected_time_table.id,
            service_id: this.selected_time_table.service_id,
            pay: 1,
            reserve: 0,
            need_callback: 1,
          })
          .then(response => {
            if (response.status === 'Busy') {
              this.selected_time_table_info.available = false
              this.paymentLoading = false
              return
            }

            this.$store.dispatch('getPaymentLink', {visit_id: response.id}).then(response => {
              this.paymentLoading = false

              this.moveToPaymentPage(response)
              this.fetch()
              this.$store.dispatch('getVisits', {
                serviceTypes: ['diagnostic', 'specialization', 'otherService']
              });
              this.$store
                  .dispatch('getUserInfo');
              this.openSuccessModal()
            })
          });
    },
    makeReservation() {
      this.paymentLoading = true
      this.$store
          .dispatch('orderDoctorTimeTable', {
            timetable_id: this.selected_time_table.id,
            service_id: this.selected_time_table.service_id,
            pay: 0,
            reserve: this.isFamilyDoctor ? 0 : 1,
            need_callback: +!this.noNeedCheckbox,
          })
          .then(response => {
            this.paymentLoading = false
            if (response.status === 'Busy') {
              this.selected_time_table_info.available = false
              return false
            }
            this.fetch()
            this.closeConfirmationModal()
            this.openSuccessModal()
          });
    },
    async onSelectTimeTable(timeTable, showPrepareInfo = true) {
      this.selected_time_table = timeTable;
      this.selected_time_table_info = null;
      let clinic = this.clinics.filter((clinic) => {
        return timeTable.clinic_id === clinic.id
      })
      if (clinic) {
        this.selectedClinic = clinic[0]
      }
      if (this.selectedDoctor && (this.selectedSpecialization || this.doctor_id)) {
        this.seanceLoading = true
        let res = await getSettings();
        await this.$store.dispatch('getSettings', res)
        this.$store
            .dispatch('getTimeTableInfo', {
              timetable_id: timeTable.id,
              service_id: timeTable.service_id,
            })
            .then(timeTableInfo => {
              this.selected_time_table_info = timeTableInfo;
              if (timeTableInfo.service_prepare_info_id && showPrepareInfo) {

              } else {
                this.seanceLoading = false
              }
            })
      }
    },
    fetch() {
      let query = {
        start_at: moment().format(config.DATE_FORMAT),
        end_at: moment().add(1, 'years').format(config.DATE_FORMAT),
      };

      if (this.specialization_id) {
        query = {
          ...query,
          service_type: 'specialization',
          service_type_id: this.specialization_id,
        };
      }

      if (this.clinic_id) {
        query = {
          ...query,
          clinic_id: this.clinic_id,
        };
      }

      if (!this.doctor_id) {
        if (this.guest) {
          this.$router.push({
            name: 'order.order-choose-doctor',
            query,
          });
        } else {
          this.$router.push({
            name: 'profile.order.order-choose-doctor',
            query,
          });
        }
      }

      if (!this.specialization_id && !this.doctor_id) {
        if (this.guest) {
          this.$router.push({
            name: 'order.find-doctor',
            query,
          });
        } else {
          this.$router.push({
            name: 'profile.order.find-doctor',
            query,
          });
        }
      }

      for (let doctor of this.doctors) {
        if (doctor.odrex_id === this.doctor_id) {
          this.selectedDoctor = doctor;
          break;
        }
      }

      for (let specialization of this.specializations) {
        if (specialization.id === Number.parseInt(this.specialization_id)) {
          this.selectedSpecialization = specialization;
          break;
        }
      }

      for (let clinic of this.clinics) {
        if (clinic.id === Number.parseInt(this.clinic_id)) {
          this.selectedClinic = clinic;
          break;
        }
      }

      query = {
        ...query,
        doctor_id: !this.isFamilyDoctor ? this.doctor_id : null,
        patient_id: this.isFamilyDoctor ? this.patient.id : null,
      };

      this.$store
          .dispatch('getTimeTables', query)
          .then(({data, meta}) => {
            this.time_table_groups = data;

            for (let doctor of this.doctors) {
              if (meta['doctors'][0].id === doctor.odrex_id) {
                this.selectedDoctor = doctor;
                break;
              }
            }

          }).finally(() => {
        this.loading = false;
      });
    }
  },
  computed: {
    ...mapGetters([
      'doctors',
      'clinics',
      'specializations',
      'settings',
      'patient'
    ]),
    displayChangeExecutorButton() {
      return !this.$route.query?.my_doctor;
    },
    disableConfirmButton() {
      return this.selected_time_table === null && this.selected_time_table_info === null;
    },
    isCanBePayed(){
      return this.selected_time_table_info && this.selected_time_table_info.can_be_payed
    },
    isReservation() {
      let state = {
        operatorCall: false,
        reservation: false,
      }
      let globalReservation = this.settings.reservation_available
      let serviceReservation = this.selected_time_table_info.can_be_reserved

      if (this.isFamilyDoctor) {
        state.reservation = true
        return state;
      }
      if (serviceReservation) {
        if (globalReservation) {
          state.operatorCall = true
        } else {
          state.reservation = true
        }
      }
      return state;
    },
    isFamilyDoctor() {
      return Boolean(this.my_doctor)
    },
    routerLinkOrderChooseDoctor() {
      let query = {};

      if (this.selectedSpecialization) {
        query = {
          ...query,
          specialization_id: this.selectedSpecialization.id,
        };
      }

      if (this.selectedClinic) {
        query = {
          ...query,
          clinic_id: this.selectedClinic.id,
        };
      }

      if (this.guest) {
        return {
          name: 'order.choose-doctor',
          query,
        };
      } else {
        return {
          name: 'profile.order.choose-doctor',
          query,
        };
      }
    },
  },
  mounted() {
    if (this.specializations.length === 0) {
      this.$store.dispatch('getSpecialization').then(() => this.fetch())
    } else {
      this.fetch();
    }
  },
  components: {
    TimeTableInput,
    OperatorModal,
    prepareInfoModal
  },
}
</script>

<style lang="scss" scoped>
.doctor-not-found-card {
  max-width: 220px;
  padding: 20px;

  box-shadow: 0 2px 4px -1px rgba(163, 190, 204, 0.5), 0 0 0 1px rgba(163, 190, 204, 0.2);
  border-radius: 5px;

  & .header {
    font-size: 15px;
    font-weight: bold;
    color: #0a4766;
    margin-bottom: 10px;
  }

  & .text {
    max-width: 135px;
    font-size: 12px;
    color: #7c98a6;
    margin-bottom: 15px;
  }

  & .phone {
    font-size: 18px;
    color: #0a4766;
  }
}

.header {
  position: relative;

  & > span {
    position: relative;
    top: -7px;
  }
}

.icon__edit {
  display: inline-block;
  background-repeat: no-repeat;
  margin-left: 10px;
  position: relative;
  top: 3px;
}

.time-table {
  & button {
    width: 120px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
}
</style>
